module.exports = __webpack_public_path__ + "assets/filters-986d4e.svg";